import {
    Button,
    Card,
    Grid,
    Image,
    PasswordInput,
    Stack,
    Text,
    TextInput
} from "@mantine/core";
import { AlternateEmail, Lock } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { Auth } from "@therapprove/common";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import nellyLogin from "../../assets/nelly-login.png";
import logoFull from "../../assets/therapprove-logo-transparent-black.png";
import {
    emailValidation,
    forgotPasswordValidation
} from "./ForgotPassword.validation";

const auth = new Auth();

export const ForgotPassword = () => {
    const navigate = useNavigate();

    const [forgotPasswordPhase, setForgotPasswordPhase] = useState(0);
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const onSubmit = async (event) => {
        event.preventDefault();

        // Validate the form data
        const isFormValid = !forgotPasswordPhase
            ? await emailValidation(email)
            : await forgotPasswordValidation(
                  code,
                  newPassword,
                  confirmPassword
              );

        // If there are any validation errors on the form, don't try to execute the 'forgot password' flow
        if (!isFormValid) {
            console.error(
                "There are errors with the forgot password form data."
            );
            return;
        }

        // Do the 'send code' or 'change password flow' here
        if (!forgotPasswordPhase) {
            auth.sendVerificationCode(email, setForgotPasswordPhase);
        } else {
            auth.resetPassword(email, code, newPassword).then((didReset) => {
                if (didReset) {
                    navigate("/login");
                }
            });
        }
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            onSubmit(e);
        }
    };

    return (
        <Grid style={{ height: "100vh", overflow: "hidden" }}>
            <Grid.Col
                span={{ base: 12, lg: 6 }}
                visibleFrom="lg"
                style={{
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingTop: "5rem",
                    overflow: "hidden"
                }}
            >
                <Image
                    src={nellyLogin}
                    style={{
                        flex: 1,
                        borderRadius: "0.65rem",
                        height: "30rem",
                        maxWidth: "50rem",
                        minWidth: "25rem",
                        objectFit: "contain"
                    }}
                />
            </Grid.Col>
            <Grid.Col
                span={{ base: 12, lg: 6 }}
                style={{ height: "105vh", overflow: "auto" }}
            >
                <Card
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "var(--mantine-color-primary-1)",
                        height: "100%",
                        width: "100%",
                        overflow: "auto"
                    }}
                >
                    <Image
                        src={logoFull}
                        style={{
                            width: "60%",
                            marginTop: "1rem",
                            alignSelf: "center"
                        }}
                    />
                    <Text
                        variant="body"
                        style={{
                            marginTop: "5rem",
                            alignSelf: "center",
                            fontSize: "2rem",
                            fontWeight: 700
                        }}
                    >
                        Forgot Password
                    </Text>
                    <form onKeyDown={handleKeyDown}>
                        {!forgotPasswordPhase ? (
                            <TextInput
                                size="lg"
                                radius="md"
                                leftSection={
                                    <SvgIcon component={AlternateEmail} />
                                }
                                placeholder="Email Address"
                                autoFocus
                                style={{
                                    marginTop: "1rem",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    width: "75%"
                                }}
                                onChange={(event) =>
                                    setEmail(event.target.value)
                                }
                            />
                        ) : (
                            <>
                                <TextInput
                                    size="lg"
                                    radius="md"
                                    leftSection={<SvgIcon component={Lock} />}
                                    placeholder="Code"
                                    style={{
                                        marginTop: "1rem",
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        width: "75%"
                                    }}
                                    onChange={(event) => {
                                        setCode(event.target.value);
                                    }}
                                />
                                <PasswordInput
                                    size="lg"
                                    radius="md"
                                    leftSection={<SvgIcon component={Lock} />}
                                    placeholder="New Password"
                                    style={{
                                        marginTop: "1rem",
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        width: "75%"
                                    }}
                                    onChange={(event) => {
                                        setNewPassword(event.target.value);
                                    }}
                                />
                                <PasswordInput
                                    size="lg"
                                    radius="md"
                                    leftSection={<SvgIcon component={Lock} />}
                                    placeholder="Confirm Password"
                                    style={{
                                        marginTop: "1rem",
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        width: "75%"
                                    }}
                                    onChange={(event) => {
                                        setConfirmPassword(event.target.value);
                                    }}
                                />
                            </>
                        )}
                        <Stack
                            justify="center"
                            align="center"
                            style={{ width: "100%" }}
                        >
                            <Button
                                size="lg"
                                w="40%"
                                mt="3rem"
                                onClick={onSubmit}
                            >
                                {forgotPasswordPhase
                                    ? "Change Password"
                                    : "Send Code"}
                            </Button>
                            {forgotPasswordPhase ? (
                                <Text variant="paragraph" w="80%" mt="1rem">
                                    Password must be at least 8 characters in
                                    length and contain a number, a capital
                                    letter, a lower case letter, and a special
                                    character.
                                </Text>
                            ) : null}
                        </Stack>
                    </form>
                    <Link
                        to={"/login"}
                        style={{
                            marginTop: "2rem",
                            marginLeft: "auto",
                            marginRight: "auto"
                        }}
                    >
                        Back to Login
                    </Link>
                </Card>
            </Grid.Col>
        </Grid>
    );
};
